// import React, { useState, useEffect } from "react";
// import { useGetMobileSlidersQuery } from "../../slices/homepageSlice";

// const MobileHeroSlider = () => {
//   const { data: sliders, isLoading, isError } = useGetMobileSlidersQuery();
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Automatically change the slide every 5 seconds
//   useEffect(() => {
//     if (sliders && sliders.length > 0) {
//       const interval = setInterval(() => {
//         setCurrentIndex((prevIndex) =>
//           prevIndex === sliders.length - 1 ? 0 : prevIndex + 1,
//         );
//       }, 5000);
//       return () => clearInterval(interval);
//     }
//   }, [sliders]);

//   // Loading and error handling
//   if (isLoading) {
//     return <div>Loading...</div>;
//   }

//   if (isError || !sliders || sliders.length === 0) {
//     return <div>No mobile sliders available</div>;
//   }

//   return (
//     <div className="w-full h-[200px] relative overflow-hidden">
//       {sliders?.map((slider, index) => (
//         <div
//           key={slider._id}
//           className={`absolute top-0 left-0 w-full h-full transition-opacity duration-500 ${
//             index === currentIndex ? "opacity-100" : "opacity-0"
//           }`}
//         >
//           <img
//             src={slider.image}
//             alt={slider.title}
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute bottom-4 left-4 text-white">
//             <h2 className="text-xl">{slider.title}</h2>
//             <p className="mt-2 text-sm">{slider.message}</p>
//             <a
//               href={slider.url}
//               className="mt-2 inline-block text-sm underline"
//             >
//               Learn More
//             </a>
//           </div>
//         </div>
//       ))}

//       {/* Dots */}
//       <div className="dots absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
//         {sliders?.map((_, index) => (
//           <span
//             key={index}
//             className={`dot w-2 h-2 bg-gray-300 rounded-full cursor-pointer ${
//               index === currentIndex ? "bg-white" : ""
//             }`}
//             onClick={() => setCurrentIndex(index)}
//           ></span>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MobileHeroSlider;

import React, { useState, useEffect } from "react";
import { useGetMobileSlidersQuery } from "../../slices/homepageSlice";

const MobileHeroSlider = () => {
  const { data: sliders, isLoading, isError } = useGetMobileSlidersQuery();
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically change the slide every 5 seconds
  useEffect(() => {
    if (sliders && sliders.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === sliders.length - 1 ? 0 : prevIndex + 1,
        );
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [sliders]);

  // Loading and error handling
  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError || !sliders || sliders.length === 0) {
    return <div>No mobile sliders available</div>;
  }

  return (
    <div className="w-full h-[200px] relative overflow-hidden">
      {sliders?.map((slider, index) => (
        <div
          key={slider._id}
          className={`absolute top-0 left-0 w-full h-full transition-opacity duration-500 ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slider.image}
            alt={slider.title}
            className="w-full h-full object-cover cursor-pointer"
            onClick={() => window.open(slider.url, "_blank")}
          />
        </div>
      ))}

      {/* Dots */}
      <div className="dots absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
        {sliders?.map((_, index) => (
          <span
            key={index}
            className={`dot w-2 h-2 bg-gray-300 rounded-full cursor-pointer ${
              index === currentIndex ? "bg-white" : ""
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default MobileHeroSlider;
